import React, { useRef } from 'react'
import Button, { TYPES } from 'components/Button'
import DropInVideoPlayer, { DEFAULT_CONTROLS } from 'components/DropInVideoPlayer'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

/**
 * The video promotion modal component
 * @param {Object} props - The props
 * @param {Map} props.notification - The notification text
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onCloseClick - The handler function for close button
 * @returns {JSX.Element} NotificationsVideoPromotionModal
 */
function NotificationsVideoPromotionModal (props) {
  const {
    notification,
    staticText,
    onCloseClick,
  } = props

  const playerRef = useRef()

  const title = notification.getIn(['node', 'title'])
  const description = notification.getIn(['node', 'fields', 'teaser', 0, 'value'])
  const poster = notification.getIn(['node', 'keyart_16x9_notext', 'keyart_1180x664'])
  const buttonUrl = notification.getIn(['node', 'cta', 'path'])
  const buttonText = notification.getIn(['node', 'cta', 'label'])
  const mediaId = notification.getIn(['node', 'feature', 'nid'])

  return (
    <div className="notifications-video-promotion-modal">
      {
        mediaId
          && <div className="notifications-video-promotion-modal__video-container">
            <DropInVideoPlayer
              autoplay={false}
              mediaId={mediaId}
              playsinline
              controls={{ type: DEFAULT_CONTROLS }}
              poster={poster}
              onPlayerSuccess={(data) => {
                playerRef.current = data.ref
              }}
            />
          </div>
      }
      <div className="notifications-video-promotion-modal__content">
        <Button type={TYPES.LINK} onClick={onCloseClick} className="notifications-video-promotion-modal__close" />
        { title && <header className="notifications-video-promotion-modal__header">{title}</header> }
        { description && <p className="notifications-video-promotion-modal__text">{description}</p>}
        {buttonUrl && buttonText
          ? <Button
            className="notifications-video-promotion-modal__button"
            type={TYPES.PRIMARY}
            onClick={onCloseClick}
            target={'_blank'}
            url={buttonUrl}
          >
            {buttonText}
            <IconV2 type={ICON_TYPES.CHEVRON_RIGHT} />
          </Button>
          : <Button
            className="notifications-video-promotion-modal__button"
            type={TYPES.PRIMARY}
            onClick={() => playerRef.current && playerRef.current.play()}
          >
            {staticText.get('playVideo')}
          </Button>
        }
      </div>
    </div>
  )
}

export default NotificationsVideoPromotionModal
